import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "../../../../../styles/userManagement.css"
import ModalComponent from '../../../../Common/DeleteModal'
import displayToastMessage from "../../../../Common/Alert/displayToastMessage"
import ViewAllThirdPartyRequests from './ViewThirdPartyRequests.js'
import useHttp from "../../../../../hooks/useHttp.js";
import APIService from "../../../../../services/apiAxiosService.js";

function ViewThirdPartyRequests(props) {

  const [modalVisible, setModalVisible] = useState(false);
  const [currentTab, SetTab] = useState("1");
  const [allRequests, setAllRequests] = useState([])
  const [dataLoader, setDataLoader] = useState(true)
  const { sendRequest: getCreatedTPRequests } = useHttp();


  useEffect(() => {
    getInitialDataHandler();
  }, []);

  const responseHandler = (json) => {
    if (json.CODE) {
      setAllRequests(json.MSG)
      setDataLoader(false)
    }
  }

  const errorHandler = () => {
    displayToastMessage("Something went wrong, Please try again!", "error");
    setDataLoader(false)
  }

  let getInitialDataHandler = () => {
    getCreatedTPRequests(APIService.getCreatedTPRequestsService(), 
    responseHandler, 
    errorHandler
    )
  }

  const handleTabs = (e, v) => {
    SetTab(v);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };
  const handleConfirm = () => {
    setModalVisible(false);
    displayToastMessage("Deleted Successfully", "success")
  };

  return (
    <div className="App user-management-container">
      <Tabs defaultValue={currentTab}
        value={currentTab}
        onChange={handleTabs} className="a-tab-item-padding-10">
        <Tab value="1" label="Third Party Information">
            <div>
              <ViewAllThirdPartyRequests vendorRequests={allRequests} />
              <ModalComponent visible={modalVisible} cancel={handleCancel} confirm={handleConfirm} />
          </div>
        </Tab>
      </Tabs>
    </div >
  );
}
export default ViewThirdPartyRequests;
